import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import TopFieldContent from '../../../../../Components/Form/components/TopFieldContent';
import useFormName from '../../../../../Hooks/useFormName';
import ErrorMessage from '../../../../../Components/Form/components/ErrorMessage';
import P1PaymentCoverageType from './P1PaymentCoverageType';
import { SelectValue } from '../../../../../Components/Base/Select/Select';

interface Props {
	name: string;
	label?: string;
	isRequired?: boolean;
	className?: string;
	onChange?: (value: SelectValue) => void;
}

const P1PaymentCoverageTypeField: React.FC<Props> = ({
	name,
	label,
	className,
	isRequired,
}) => {
	const { fieldName } = useFormName({ name });
	const { control } = useFormContext();

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName,
	});

	return (
		<div className={className}>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			<P1PaymentCoverageType {...field} />
			{error?.message && <ErrorMessage tx={error.message} />}
		</div>
	);
};

export default P1PaymentCoverageTypeField;
